export default __webpack_public_path__ + "static/thumbnail-22442eed25684f2d790c3b68ed6650c9.png";